module.exports = __webpack_public_path__ + "img/girl.12653773.svg";